import * as React from "react"
import BlogCard from "./blog-card"
import { useStaticQuery, graphql } from "gatsby"

const RecommendedReading = (props) => {
    
    const data = useStaticQuery(
        graphql`
            query {
            allContentfulBlogPost(
                sort: {fields: postDate, order: DESC}
            ) {
                edges {
                    node {
                        title
                        id
                        slug
                        category
                        subcategories
                        postDate(formatString: "MMMM D, YYYY")
                        featuredImage {
                            fluid(maxWidth: 750) {
                                src
                            }
                        }
                    }
                }
            }
        }
    `)
    
    let selectedBlogs = []

    for(var i = 0; i < data.allContentfulBlogPost.edges.length; i++){
        if(data.allContentfulBlogPost.edges[i].node.category === props.category && data.allContentfulBlogPost.edges[i].node.title !== props.title){
            selectedBlogs.push(data.allContentfulBlogPost.edges[i])
        }
        
        if(selectedBlogs.length === 3){
            break
        }
    }

    if(selectedBlogs.length < 3){
        for(var i = 0; i < data.allContentfulBlogPost.edges.length; i++){
            if(data.allContentfulBlogPost.edges[i].node.subcategories !== null){
                if(data.allContentfulBlogPost.edges[i].node.subcategories.includes(props.category) && data.allContentfulBlogPost.edges[i].node.title !== props.title){
                    if(!selectedBlogs.includes(data.allContentfulBlogPost.edges[i])){
                        selectedBlogs.push(data.allContentfulBlogPost.edges[i])
                    }
                }
            }
            
            
            if(selectedBlogs.length === 3){
                break
            }
        }
    }

    const recommendedReading = selectedBlogs.map((edge, i) => {
        return(
            <div className='col-lg-4 col-md-6' key={i}>
                <BlogCard 
                    title={edge.node.title}
                    link={`/blog/${edge.node.slug}/`}
                    image={edge.node.featuredImage}
                    category={edge.node.category}
                />
            </div>
        )
    }) 

    return (
        <div className='row justify-content-center g-4'> 
            {recommendedReading} 
        </div>
    )
}

export default RecommendedReading